import { render, staticRenderFns } from "./WorksheetOverviewDashboardView.vue?vue&type=template&id=5ad56e56&scoped=true&"
import script from "./WorksheetOverviewDashboardView.vue?vue&type=script&lang=js&"
export * from "./WorksheetOverviewDashboardView.vue?vue&type=script&lang=js&"
import style0 from "./WorksheetOverviewDashboardView.vue?vue&type=style&index=0&id=5ad56e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad56e56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VContainer,VDivider,VRow})
